import React from 'react';
import { FiAlertCircle, FiCheckCircle, FiXCircle } from 'react-icons/fi';

/**
 * InlineBanner - compact in-page notice (error / success) used on the
 * Property Managers screens instead of fixed-position MUI alerts.
 */
export default function InlineBanner({ tone = 'error', children, onClose, className = '' }) {
  const styles = {
    error: 'border-red-200 bg-red-50 text-red-700',
    success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  };
  const Icon = tone === 'success' ? FiCheckCircle : FiAlertCircle;

  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`mb-3 flex items-start justify-between gap-3 rounded-xl border px-4 py-3 text-sm ${styles[tone] || styles.error} ${className}`}
    >
      <div className="flex items-start gap-2">
        <Icon className="mt-0.5 h-4 w-4 shrink-0" />
        <div>{children}</div>
      </div>
      {onClose ? (
        <button type="button" onClick={onClose} aria-label="Dismiss" className="opacity-70 transition hover:opacity-100">
          <FiXCircle className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  );
}
